module.exports = __webpack_public_path__ + "img/right-arrow.9c9b161b.svg";